
import { connect } from 'react-redux'
import React from 'react'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

import { Game, Firebase } from '../../../../Core'

import { Grid, qrToWorld } from '../../../../Hex-map'
import * as Util from '../../../Util/util'

import * as MapSelectors from '../../map.selectors'
import * as PhasesSelectors from '../../../Phases/phases.selectors'
import * as IndicatorsSelectors from '../../../Indicators/indicators.selectors'
import * as MiningSelectors from '../../../Mining/mining.selectors'
import * as SettingsSelectors from '../../../Settings/settings.selectors'

import * as MapActions from '../../map.actions'
import * as SavePointActions from '../../../SavePoint/savePoint.actions'

import { seeds } from '../../seeds'

import * as HexUtils from '../../../../Hex-map/util'
import { MODIFICATIONS } from '../../../../Hex-map'

class ObjectUpdater extends React.Component {
  /****/

  constructor(props) {
    super(props)
  }

  componentDidUpdate(prevProps) {
    const {
      userMap,
      listenerType,
      view,
      currentOptions,
      currentGrid,
      attacking,
      storeSprites,
      storyLineSprites,
      phaseInfo,
      displayinType,
      setAlertData,
      countDisputes,
      userData,
      groupData,
      visitorMap,
      shadowState,
    } = this.props

    let storeName = listenerType.storeName
    let visiting = visitorMap.mapId
    if (!visiting && storeName == 'visitorMap') {
      storeName = 'userMap'
    }

    if (storeName) {
      let oldMap = prevProps[storeName]
      let currentMap = this.props[storeName]

      //CHECK PLAYER INTERACTION WITH FIREBASE
      if (currentMap && oldMap && currentMap != oldMap && view) {
        if (!listenerType.name) {
          let new_buildings = Util.getDiffState(oldMap, currentMap)
          // BUILDING_CREATE
          for (let b in new_buildings.creations) {
            this.createBuilding(new_buildings.creations[b])
          }

          for (let b in new_buildings.updates) {
            this.updateBuilding(new_buildings.updates[b])
          }
          // // BUILDING_UPDATE
          // for (let b in new_buildings.updates) {
          //   this.updateBuilding(new_buildings.creations[b])
          // }
          // // BUILDING_DELETE
          // for (let b in new_buildings.deletions) {
          //   this.removeBuilding(new_buildings.creations[b])
          // }
          // // MOUNTAIN DEMOLISH
          // for (let b in new_buildings.rockRemoving) {
          //   this.removeMountain(new_buildings.creations[b])
          // }
        }

        switch (listenerType.name) {
          case 'BUILDING_CREATE': {
            let new_building = Util.getModifiedAttributes(currentMap.buildings, oldMap.buildings)
            this.createBuilding(Object.values(new_building)[0])
            break
          }
          case 'BUILDING_UPDATE': {
            let updated_building = Util.getModifiedAttributes(
              currentMap.buildings,
              oldMap.buildings
            )
            this.updateBuilding(Object.values(updated_building)[0])
            break
          }
          case 'BUILDING_DELETE': {
            let deleted_building = Util.getModifiedAttributes(
              oldMap.buildings,
              currentMap.buildings
            )
            this.removeBuilding(Object.values(deleted_building)[0])
            break
          }
          case 'MOUNTAIN_DEMOLISH': {
            let new_removedRock = Util.getModifiedAttributes(
              currentMap.removedRocks,
              oldMap.removedRocks
            )
            this.removeMountain(Object.values(new_removedRock)[0])
            break
          }
        }
      }
    }

    //UPDATE MAP ELEMENTS BASED ON PROPS
    if (prevProps.view == null && view) {
      this.loadElementsIn(userMap)
    } else if (!prevProps.visitorMap.mapId && visitorMap.mapId) {
      let mapData = seeds[visitorMap.mapId]
      let visitorGrid = new Grid(mapData.data._width, mapData.data._height)
      visitorGrid.init(mapData.data.data)
      view.load(visitorGrid, currentOptions)
      this.loadElementsIn(visitorMap, true)
    } else if (prevProps.visitorMap.mapId && !visitorMap.mapId) {
      view.load(currentGrid, currentOptions)
      this.loadElementsIn(userMap, true)
    } else if (attacking != prevProps.attacking) {
      let usingMap = visitorMap.mapId ? visitorMap : userMap
      this.loadElementsIn(usingMap, true)
    } else if (prevProps.displayinType != displayinType) {
      let usingMap = visitorMap.mapId ? visitorMap : userMap
      let currentChain = displayinType
        ? Object.values(usingMap.buildings).filter((building) => building.type == displayinType)
        : null
      let oldChain = prevProps.displayinType
        ? Object.values(usingMap.buildings).filter(
            (building) => building.type == prevProps.displayinType
          )
        : null

      if (currentChain && !oldChain) {
        this.reloadBuildingChain(currentChain, 'setDisplayType', true)
      } else if (!currentChain && oldChain) {
        this.reloadBuildingChain(oldChain, 'setDisplayType', false)
      } else if (currentChain && oldChain && currentChain != oldChain) {
        this.reloadBuildingChain(oldChain, 'setDisplayType', false)
        this.reloadBuildingChain(currentChain, 'setDisplayType', true)
      }
    }

    view.setShadows(shadowState)

    /* START OF SPRITES MANAGEMENTS */
    let sprites = Object.keys(storeSprites)
    let isLastTurn = false
    if (userData.turn % groupData.maxTurns === 0) {
      isLastTurn = true
    }
    let lastSession = false
    if (groupData.session === groupData.sessions) {
      lastSession = true
    }
    if (countDisputes > 0) {
      setAlertData('disputes_pending_alert')
    } else if (isLastTurn && !lastSession) {
      setAlertData('last_turn_alert')
    } else if (isLastTurn && lastSession) {
      setAlertData('last_turn_of_game_alert')
    } else {
      setAlertData(null)
    }
    sprites.map((key) => {
      let sprite = storeSprites[key]
      let sprite_conf = storyLineSprites[sprite.name]
      let multiple = sprite_conf.multiple ? sprite_conf.multiple : null
      let material = sprite_conf.material ? sprite_conf.material : null
      let store = sprite.name == 'click_me' ? phaseInfo : sprite.store

      let canDisplay = Game.evaluateAll(sprite_conf.displayConditions, store)
      if (canDisplay) {
        view.addSprite2D(
          key,
          Util.asset(sprite_conf.asset),
          sprite_conf.rotation,
          sprite.position,
          sprite_conf.scale,
          sprite_conf.animations,
          multiple,
          material
        )

        if (sprite.name == 'click_me' && !visitorMap.mapId) {
          setAlertData('mine_alert')
        }
      } else {
        view.removeSprite2D(key)
      }
    })
  }

  reloadBuilding(building3D, parameter, value) {
    const { parameters, buildings, meshModifications, view, storyAnimations } = this.props

    if (building3D[parameter] instanceof Function) {
      building3D[parameter](value)
    } else {
      building3D[parameter] = value
    }

    let b_config = buildings[building3D.getName()]
    let building_modifications = parameters[building3D.getName()]
      ? parameters[building3D.getName()].modifications
      : null

    building3D.setCurrentAnimation(
      HexUtils.hasAnyRunningAnimation(building3D, b_config.animations, storyAnimations)
    )

    building3D.onLoadModel = (model) => {
      let store = Object.assign({}, building3D)

      if (building_modifications && Object.keys(building_modifications).length > 0) {
        HexUtils.handleCustomParams(building_modifications, MODIFICATIONS.TYPE_MESH, (mod) => {
          HexUtils.assignMeshParameters(store, model, mod, meshModifications)
        })
      }

      view.checkAnimation(store, building3D, store._animations)
    }

    building3D.load()
    this.createCustomModels(building3D)
  }

  canAttack(building) {
    const { userMap, visitorMap, visitorInfo, attacking } = this.props

    return Util.canAttack(building, userMap, visitorMap, visitorInfo, attacking)
  }

  reloadBuildingChain(chain, parameter, value) {
    const { view } = this.props

    chain.map((item) => {
      let item3D = view.getSceneElementByName(item.q + '_' + item.r)
      this.reloadBuilding(item3D, parameter, value)
    })
  }

  removeBuilding(building) {
    const { view, parameters } = this.props

    if (view && building) {
      let buildingName = building.q + '_' + building.r
      let building3D = view.getSceneElementByName(buildingName)
      if (building3D) {
        let building_modifications = parameters[building.name]
          ? parameters[building.name].modifications
          : null
        view.removeFromSceneByName(buildingName)
        if (building_modifications && Object.keys(building_modifications).length > 0) {
          HexUtils.handleCustomParams(
            building_modifications,
            MODIFICATIONS.TYPE_CUSTOM_MODELS,
            (mod) => {
              Object.keys(mod.customModels).map((customModel) => {
                view.removeFromSceneByName(customModel + '_' + building.q + '_' + building.r)
              })
            }
          )
        }
        this.removeSprites(building)
      }
    }
  }

  removeMountain(mountain) {
    const { view, terrainVariants, customModels, meshModifications, buildings } = this.props
    let mountainConfig = {
      customModels: {
        debris: {
          parentPosition: true,
        },
        rover: {
          parentPosition: true,
        },
      },
    }

    if (view && mountain) {
      view.removeMountain(terrainVariants, mountain)
      if (mountain.destroying !== true) {
        view.createCustomModel(mountain, mountainConfig, customModels, meshModifications)
      }
      let currentPos = qrToWorld(mountain.q, mountain.r).toArray()
      currentPos[2] = currentPos[2] + buildings['debris_build'].heights[0]

      this.checkSprites(mountain, currentPos)
    }
  }

  removeSprites(building) {
    const { storyLineSprites, removeSprite } = this.props

    //REMOVE SAVED SPRITES
    Object.keys(storyLineSprites).map((spriteName) => {
      let spriteKey = `${spriteName}_${building.q}_${building.r}`

      if (building.type != 'mine' && spriteName != 'click_me') {
        removeSprite(spriteKey)
      }
    })
  }

  checkSprites(building, pos) {
    const { storyLineSprites, addSprite } = this.props

    let store = Object.assign({}, building)
    let currentPos = [...pos]
    currentPos[0] = currentPos[0] - 0.6

    //CHECK UPDATED OR ADD SPRITES
    Object.keys(storyLineSprites).map((spriteName) => {
      let spriteKey = `${spriteName}_${building.q}_${building.r}`

      if (building.type != 'mine' && spriteName != 'click_me' && !building.terrain) {
        addSprite(spriteKey, spriteName, currentPos, store)
      } else if (
        building.terrain &&
        building.terrain == 'mountain' &&
        spriteName == 'badge_descombro'
      ) {
        addSprite(spriteKey, spriteName, currentPos, store)
      }
    })
  }

  loadElementsIn(map, clear = false) {
    const { view, userData } = this.props

    if (clear) {
      view.clearAllElements()
    }

    if (view && map) {
      let buildings = Object.values(map.buildings)
      let removedRocks = Object.values(map.removedRocks)

      buildings.map((building) => {
        this.createBuilding(building)
      })

      removedRocks.map((rock) => {
        if (rock.destroying >= userData.turn || rock.destroying == true) {
          this.removeMountain(rock)
        }
      })

      let tile = view.pickTile(view.tileSelector.position.clone())
      view.selectTile(tile)
    }
  }

  updateBuilding(building) {
    const {
      view,
      buildings,
      parameters,
      meshModifications,
      storyAnimations,
      attacking,
      visitorMap,
    } = this.props

    if (view) {
      let building3D = view.getSceneElementByName(building.q + '_' + building.r)
      let b_config = buildings[building.name]
      let visiting = visitorMap.mapId
      let building_modifications = parameters[building.name]
        ? parameters[building.name].modifications
        : null
      if (building3D) {
        building3D.setBuilt(building.built)
        building3D.setEvolving(building.evolving)
        building3D.setBlocked(building.blocked)
        building3D.setDestroying(building.destroying)
        building3D.setName(building.name)
        building3D.setType(building.type)
        building3D.setLevel(building.level)
        building3D.setType(building.type)
        building3D.setProductionAmount(b_config.productionAmount)
        building3D.setPricePerLevel(b_config.pricePerLevel)
        building3D.setProductionMultiplier(building.mutiplier)

        building3D.setCurrentAnimation(
          HexUtils.hasAnyRunningAnimation(building3D, b_config.animations, storyAnimations)
        )

        if (visiting) {
          if (!this.canAttack(building) && attacking && !building.blocked) {
            building3D.setDisabled(true)
          } else {
            building3D.setDisabled(false)
          }
        }

        building3D.onLoadModel = (model) => {
          let store = Object.assign({}, building3D)

          if (building_modifications && Object.keys(building_modifications).length > 0) {
            HexUtils.handleCustomParams(building_modifications, MODIFICATIONS.TYPE_MESH, (mod) => {
              HexUtils.assignMeshParameters(store, model, mod, meshModifications)
            })
          }

          view.checkAnimation(store, building3D, store._animations)
        }

        this.createCustomModels(building3D)
        building3D.load(Util.asset(b_config.assets[building.level - 1]))

        let currentPos = building3D.position.clone().toArray()
        currentPos[2] = currentPos[2] + b_config.heights[building.level - 1]

        this.checkSprites(building, currentPos)
      }
    }
  }

  createCustomModels(parent) {
    const { meshModifications, customModels, view, parameters } = this.props

    if (!parent) {
      return null
    }

    const building_modifications = parameters[parent.getName()]
      ? parameters[parent.getName()].modifications
      : null

    if (building_modifications) {
      HexUtils.handleCustomParams(
        building_modifications,
        MODIFICATIONS.TYPE_CUSTOM_MODELS,
        (mod) => {
          view.createCustomModel(parent, mod, customModels, meshModifications)
        }
      )
    }
  }

  createBuilding(building) {
    const {
      buildings,
      view,
      parameters,
      meshModifications,
      addSprite,
      attacking,
      storyAnimations,
      visitorMap,
    } = this.props

    if (view && building) {
      let building_config = buildings[building.name]
      let building_modifications = parameters[building.name]
        ? parameters[building.name].modifications
        : null
      let visiting = visitorMap.mapId

      if (building_config) {
        const position = qrToWorld(building.q, building.r).clone()
        let building3D = view.createBuilding3D(
          building.name,
          position.clone(),
          Util.asset(building_config.assets[building.level - 1]),
          building_config.type,
          building_config.maxLevel,
          building_config.animations,
          building_config.productionAmount,
          building_config.pricePerLevel,
          building.level,
          building.built,
          building.evolving,
          building.destroying,
          building.blocked
        )

        building3D.setProductionMultiplier(building.multiplier)

        let currentPos = position.toArray()
        currentPos[2] = currentPos[2] + building_config.heights[building.level - 1]

        if (visiting) {
          if (!this.canAttack(building) && attacking && !building.blocked) {
            building3D.setDisabled(true)
          } else {
            building3D.setDisabled(false)
          }
        } else {
          if (building_config.type == 'mine') {
            addSprite(`click_me_${building.q}_${building.r}`, 'click_me', [...currentPos])
          }
        }

        building3D.setCurrentAnimation(
          HexUtils.hasAnyRunningAnimation(building3D, building_config.animations, storyAnimations)
        )

        building3D.onLoadModel = (model) => {
          let store = Object.assign({}, building3D)

          if (building_modifications && Object.keys(building_modifications).length > 0) {
            HexUtils.handleCustomParams(building_modifications, MODIFICATIONS.TYPE_MESH, (mod) => {
              HexUtils.assignMeshParameters(store, model, mod, meshModifications)
            })
          }

          view.checkAnimation(store, building3D, building_config.animations)
        }

        this.createCustomModels(building3D)
        building3D.load()
        this.checkSprites(building, currentPos)
      }
    }
  }

  /**
   *  Render component
   *  @return {React.Component} The component
   */
  render() {
    return <div></div>
  }
}

const mapDispatchToProps = (dispatch) => ({
  selectTile: bindActionCreators(MapActions.selectCurrentTile, dispatch),
  addSprite: bindActionCreators(MapActions.addSprite, dispatch),
  removeSprite: bindActionCreators(MapActions.removeSprite, dispatch),
  setAlertData: bindActionCreators(SavePointActions.setAlertData, dispatch),
})

const mapStateToProps = (state) => {
  return {
    terrainVariants: MapSelectors.getTerrainVariants(state),
    // listenerType: FirebaseSelectors.getListenerType(state),
    displayinType: IndicatorsSelectors.getDisplayingType(state),
    buildings: MapSelectors.getBuildings(state),
    currentPhase: PhasesSelectors.getCurrentPhase(state),
    // visitorMap: MapSelectors.getVisitorMap(state),
    // visitorInfo: MapSelectors.getVisitorInfo(state),
    parameters: MapSelectors.getBuildingParameters(state),
    meshModifications: MapSelectors.getMeshModifications(state),
    customModels: MapSelectors.getSimpleModels(state),
    attacking: MapSelectors.getAttackState(state),
    userData: IndicatorsSelectors.getUserData(state),
    storyLineSprites: MapSelectors.getStoryLineSprites(state),
    storyAnimations: MapSelectors.getAnimations(state),
    storeSprites: MapSelectors.getStoreSprites(state),
    countDisputes: MiningSelectors.getCountDisputes(state),
    groupData: Firebase.selectors.getGroupData(state),
    shadowState: SettingsSelectors.getShadowState(state),
  }
}

ObjectUpdater.propTypes = {
  userMap: PropTypes.object,
  view: PropTypes.object,
  visitorMap: PropTypes.object,
  storyAnimations: PropTypes.object,
  visitorInfo: PropTypes.object,
  storeSprites: PropTypes.object,
  storyLineSprites: PropTypes.object,
  displayinType: PropTypes.string,
  currentGrid: PropTypes.object,
  currentOptions: PropTypes.object,
  phaseInfo: PropTypes.object,
  parameters: PropTypes.object,
  customModels: PropTypes.object,
  meshModifications: PropTypes.object,
  userData: PropTypes.object,
  groupData: PropTypes.object,
  terrainVariants: PropTypes.array,
  attacking: PropTypes.bool,
  shadowState: PropTypes.bool,
  setAlertData: PropTypes.func,
  removeSprite: PropTypes.func,
  addSprite: PropTypes.func,
  listenerType: PropTypes.object,
  buildings: PropTypes.object,
  countDisputes: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(ObjectUpdater)
